import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useVote } from './hooks/useVote';

import { ResultQuiz } from './components/ResultQuiz/ResultQuiz';
import { MessagesList } from './components/MessagesList/MessagesList';
import { useMemo } from 'react';
import { useGetParams } from './hooks/useGetParams';

import defaultBackground from './assets/images/bg.png';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, messagesRef, winnerMessage, speed } =
    useCarousel(currentState);

  const { bg, bgColor } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  const correctVar = voteState?.vars && voteState.vars.find((v) => v.correct);
  const notCorrectVar =
    voteState?.vars &&
    voteState.vars.reduce(
      (acc, v) =>
        !v.correct ? [...acc, v.comment?.trim()?.split(' ')?.[0]] : acc,
      [],
    );

  return (
    <div
      className="app-wrapper"
      style={{ background, '--speed': `${speed}ms` }}
    >
      <AnimatePresence mode="wait">
        {currentState && (
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            transition={{ duration: 1 }}
            exit={{
              x: '-100%',
              transition: {
                delay: 1,
                duration: 0.5,
              },
            }}
            className="bgMotion"
          />
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            key={`${correctVar?.varImgUrl}-result`}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="motionBlock"
          >
            <ResultQuiz correctVar={correctVar} notCorrectVar={notCorrectVar} />
          </motion.div>
        )}

        {['S2', 'S3', 'S4', 'S5'].includes(currentState) && (
          <motion.div key="msgs" className="motionBlock">
            <MessagesList
              key="msgList"
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
              messagesRef={messagesRef}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader" />
    </div>
  );
}

export default App;
